import request from "../utils/request"

export function fetchAgentWorkflowList() {
  return request({
    url: "/agent-workflows",
    method: "get"
  })
}

export function fetchAgentWorkflowDetail(id) {
  return request({
    url: `/agent-workflows/${id}`,
    method: "get"
  })
}

export function fetchAgentWorkflowNodeCatalog() {
  return request({
    url: "/agent-workflows/node-catalog",
    method: "get"
  })
}

export function createAgentWorkflow(data) {
  return request({
    url: "/agent-workflows",
    method: "post",
    data
  })
}

export function updateAgentWorkflow(id, data) {
  return request({
    url: `/agent-workflows/${id}`,
    method: "put",
    data
  })
}

export function deleteAgentWorkflow(id) {
  return request({
    url: `/agent-workflows/${id}`,
    method: "delete"
  })
}
